import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { ConstantsService } from './constants.service';
import { ApiService } from './api.service';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    public apiBaseUrl: any;
    baseURL: string = this.constantsService.API_URL_USER;

    constructor(public constantsService: ConstantsService, private apiService: ApiService, private httpService: HttpService) {
        this.apiBaseUrl = environment.SERVER_ROOT_URL
    }

    /*
     *  Read user role
     */
    getRole(username: string): Observable<any> {
        let requestObject = {
            API_URL: this.baseURL + '/role/' + username,
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
        };
        return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
    }

    getSavedPreferences(): Observable<any> {
        let username = JSON.parse(localStorage.getItem('username') || '')
        let requestObject = {
            API_URL: this.baseURL + '/userpreferences/' + username._value,
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
        };
        return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
    }

    getPreferences() {
        let user_id = JSON.parse(localStorage.getItem('username') || '');
        let requestObject = {
            API_URL: `/User/user-preferences/${user_id._value}`, 
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
        };

        return this.httpService
            .sendRequest(requestObject)
            .pipe(map(this.extractData));
    }

    updatePreference(reqBody: any) {
        let requestObject = {
            BODY: reqBody,
            API_URL: '/User/modify-user-preferences',
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST
        };
        return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));

    }

    getRegions(): Observable<any> {
        let username = JSON.parse(localStorage.getItem('username') || '')
        let requestObject = {
            // API_URL:this.baseURL+'/get-regions/'+ username._value,
            API_URL: this.baseURL + '/get-regions',
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
        };
        return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
    }


    getClientNames() {
        let requestObject = {
            API_URL: '/api/file-processing/get-client-data',
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
        };
        return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
    }

    getBrands(clientKey: any) {
        let requestObject = {
            BODY: {
                client_key: clientKey || null,
            },
            API_URL: '/api/filter/get-brand-filter',
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_POST
        };
        return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
    }

    getUserPreferrence(clientkey: any) {
        let requestObject = {
            // API_URL:this.baseURL+'/get-regions/'+ username._value,
            API_URL: `/User/get-preferences/${clientkey}`,
            REQUEST_METHOD: this.constantsService.REQUEST_METHOD_GET
        };
        return this.httpService.sendRequest(requestObject).pipe(map(this.extractData));
    }

    /*
     *  Extract data from response
     */
    private extractData(res: Response) {
        let body = res;
        return body || {};
    }
}
